import GlobalVariable from '@/global/global-variable'

// 查询异常日志
const searchException = GlobalVariable.BASE_PATH + "/rest/system/log/searchException";

// 查询操作日志
const searchOperate = GlobalVariable.BASE_PATH + "/rest/system/log/searchOperate";

// 查询日志模块
const findOperateModule = GlobalVariable.BASE_PATH + "/rest/system/log/findOperateModule";

// 查询日志类型
const findOperateType = GlobalVariable.BASE_PATH + "/rest/system/log/findOperateType";

export default {
    searchException,
    searchOperate,
    findOperateModule,
    findOperateType,
}



// WEBPACK FOOTER //
// ./src/request/api-log.js